var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "card", attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("load-settings")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.fetching
        ? _c(
            "w-card-content",
            { staticClass: "loading-container" },
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", center: "" } },
                    [_c("w-progress-circular", { attrs: { large: "" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            [
              _vm.noItems
                ? _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", [
                        _vm._v(_vm._s(_vm.$ct("no-saved-settings"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.items, function (item) {
                return _c(
                  "w-list-item",
                  {
                    key: item.ID,
                    class: { active: item == _vm.selectedItem },
                    on: {
                      click: function ($event) {
                        return _vm.load(item)
                      },
                    },
                  },
                  [
                    _c("w-list-item-text", [
                      _vm._v(" " + _vm._s(item.Name) + " "),
                    ]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("common.delete"),
                                expression: "$ct('common.delete')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.deleteItem(item)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._l(_vm.staticItems, function (item) {
                return _c(
                  "w-list-item",
                  {
                    key: item.uid,
                    on: {
                      click: function ($event) {
                        return _vm.loadStatic(item.Settings)
                      },
                    },
                  },
                  [_c("w-list-item-text", [_vm._v(_vm._s(item.Name))])],
                  1
                )
              }),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }